import Axios from "axios";
import { VideoResponse } from "../types/videos";
import { handleApiError } from "./apiErrorHandler";

export const getVideos = async (path: string): Promise<VideoResponse> => {
  try {
    var res = await Axios.get(`./api/videos/${path}`);
    return res.data;
  } catch (error) {
    return handleApiError(error);
  }
};
